var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiMenuItemOverrides = function (_a) {
    var typography = _a.typography;
    return {
        styleOverrides: {
            root: __assign(__assign({}, typography.body2), { height: 32, border: 'none', '&:last-child': {
                    borderBottom: 'none',
                } }),
        },
    };
};
